import { publicationsApi } from '../services/publications';
import { webinarsApi } from '../services/webinars';
import { authorApi } from '../services/author';
import { analyticsReadersApi } from '../components/Analytics/services/readers';
import { analyticsCoursesPostsApi } from '../components/Analytics/services/posts';
import { analyticsWebinarsApi } from '../components/Analytics/services/webinars';
import { recommendationApi } from '../components/Recommendation/services';

export const coursesApi = [
    publicationsApi.middleware,
    webinarsApi.middleware,
    analyticsReadersApi.middleware,
    analyticsCoursesPostsApi.middleware,
    authorApi.middleware,
    analyticsWebinarsApi.middleware,
    recommendationApi.middleware,
];

export const coursesReducers = {
    [publicationsApi.reducerPath]: publicationsApi.reducer,
    [webinarsApi.reducerPath]: webinarsApi.reducer,
    [authorApi.reducerPath]: authorApi.reducer,
    [analyticsReadersApi.reducerPath]: analyticsReadersApi.reducer,
    [analyticsCoursesPostsApi.reducerPath]: analyticsCoursesPostsApi.reducer,
    [analyticsWebinarsApi.reducerPath]: analyticsWebinarsApi.reducer,
    [recommendationApi.reducerPath]: recommendationApi.reducer,
};
